import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "@pressmedia/vuwcolony";
import defaultSlickOptions from "@@assets/scripts/importSlick";
import articleTemplate from "./articleTemplate";
import initArticle from "./initArticle";

vuwer.appendKlass("VuwSlider", {
	classNames: {
		self: "vuw-slider",
		item: "vuw-slide-item",
		itemContainer: "vuw-slide-item-container"
	},
	
	itemsPerSlideForPC: 3,
	
	_defaultOptions: {
		...Klass("VuwColony").prototype._defaultOptions,
		articleTemplate,
		initArticle,
		showPager: false
	},
	
	/**
	 * [コンストラクタ]
	 *
	 * @param {Object} [opt]
	 * @returns this | false
	 */
	_initialize(opt) {
		if( u_.isObject(opt) ) {
			// onReadyLastが指定されている場合は退避
			if( u_.isFunction(opt.onReadyLast) ) {
				this._onReadyLast = opt.onReadyLast;
				delete opt.onReadyLast;
			}
			
		} else {
			opt = {};
		}
		
		u_.isObject(opt.slickOptions) || (opt.slickOptions = {});
		
		const _super_ = Klass("VuwSlider").parent._initialize.bind(this);
		if( !_super_(opt) ) {
			return false;
		}
		
		return this;
	},
	
	onReadyFirst($self) {
		if($self) {
			$self.addClass(this.classNames.self);
			const elm = $self.get(0);
			elm.vuw = this;
			Klass("VuwSlider").observer.observe(elm);
		}
		
		const _super_ = Klass("VuwSlider").parent.onReadyFirst.bind(this);
		return _super_(...arguments);
	},
	
	async onReadyLast($self) {
		if($self) {
			if(this.module && this.autoLoad) {
				await this.initList();
			}
			
			const $slides = $self.children().addClass(this.classNames.item);
			this.setProp({ $slides });
			
			this.updateSlides();
			
			vuwer.$window.on("resize", e => {
				clearTimeout(this._resizeTimer);
				this._resizeTimer = setTimeout(() => this.updateSlides(), 200);
			});
		}
		
		const args = u_.getAsArray(arguments);
		if( u_.isFunction(this._onReadyLast) ) {
			return this._onReadyLast(...args);
		}
	},
	
	
	getMQ() {
		let rtn = "sp";
		if(
			this.$slides &&
			this.$slides.length &&
			parseInt( this.$slides.eq(0).css("flex-basis") )
		) {
			rtn = "pc";
		}
		return rtn;
	},
	
	updateSlides() {
		const mq = this.getMQ();
		if(mq !== this.mq) {
			this.isSlides = false;
			this.$self.hasClass("slick-initialized") && this.$self.slick("unslick");
			
			this.$self.children(`.${this.classNames.itemContainer}`).each((i, elm) => {
				$(elm).children().eq(0).unwrap();
			});
			
			if(mq === "sp") {
				this.$slides.wrap( $("<div/>").addClass(this.classNames.itemContainer) );
				
			} else {
				const { itemsPerSlideForPC } = this;
				let $slideItems;
				this.$slides.each((i, elm) => {
					const mod = i % itemsPerSlideForPC;
					if(!mod) {
						$slideItems = $(elm);
					} else {
						$slideItems = $slideItems.add(elm);
					}
					
					if(mod === itemsPerSlideForPC - 1) {
						$slideItems.wrapAll(
							$("<div/>").addClass(this.classNames.itemContainer)
						);
						
						$slideItems = null;
					}
				});
				
				!!$slideItems && $slideItems.wrapAll(
					$("<div/>").addClass(this.classNames.itemContainer)
				);
			}
			
			if( this.$self.children().length > 1 ) {
				this.$self.slick({ ...defaultSlickOptions, ...this.slickOptions });
				this.isSlides = true;
			}
			
			this.mq = mq;
		}
		
		return this;
	}
}, "VuwColony");


// [IntersectionObserver as InView]
const VuwSlider = Klass("VuwSlider");
VuwSlider.observer = new IntersectionObserver(entries => {
	entries.forEach(e => {
		const { vuw } = e.target;
		if(vuw.isSlides) {
			vuw.$self.slick(e.isIntersecting ? "slickPlay" : "slickPause");
		}
	});
});


export default VuwSlider;
